import { DatePicker } from "@mui/lab";
import {
  AlertColor,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  styled,
  TextField,
  Theme,
  Typography
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios, { AxiosResponse } from "axios";
import React, { useImperativeHandle, useMemo } from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { PurchaseOrder, PurchaseOrderItem } from "./PurchaseOrderAccessories";
import { DropDownComboOption } from "../../component/GenericFilter";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import { GeneralDialog } from "../../component/GeneralDialog";
import Title from "../../component/Title";
import { GetCustLangIdsByLanguageId, Languages, defaultLabelSendTo, defaultPaymentTerm, deliveryAddress, deliveryAddressSS, deliveryAttn, deliveryAttnSS, deliveryPhone, deliveryPhoneSS, deliveryTo, deliveryToSS, sendTo } from "../../../common/Constants";
import moment from "moment";
import { CommonProps } from "../../component/MainContents";
import { CustomDropDown1 } from "../../component/CustomDropDown1";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridColDef, GridColumns, GridPreProcessEditCellProps, GridRenderCellParams, GridRowId, GridRowsProp, GridToolbarContainer, GridValueSetterParams, useGridApiContext } from "@mui/x-data-grid";
import { CustomTablePagination } from "../../component/CustomPagination";
import { Add, Clear, ContentCopy, Delete, Info, Percent, Search, SwitchLeft } from "@mui/icons-material";
import { FormatNumber, Pad } from "../../../common/Formatter";
import { ProductList, ProductListHandle } from "../products/ProductList";
import { ProductListItem } from "../products/ProductAccessories";
import { Customer, CustomerAddressItem, CustomerCombo, CustomerContactPersonItem } from "../customers/CustomerAccessories";
import { AwayFromZeroRounding, GetCustomerName, GetNoOfLines, HasDuplicates, ValidateNumber } from "../../../common/CommonFunctions";
//import { PurchaseOrderViewer, PurchaseOrderViewerHandle } from "./PurchaseOrderViewer";
import { BranchInfo } from "../branches/BranchAccessories";
import { EndUserList, EndUserListHandle } from "../end-users/EndUserList";
import { EndUserListItem } from "../end-users/EndUserAccessories";
import { PurchaseOrderViewer, PurchaseOrderViewerHandle } from "./PurchaseOrderViewer";
import { renewToken } from "../../../services/AuthService";
import { CustomerAddress, CustomerAddressHandle } from "../customers/CustomerAddress";
import { CustomerContactPerson, CustomerContactPersonHandle } from "../customers/CustomerContactPerson";
import { NumberTypes } from "../../../models/enums/NumberType";
import NumberFormat from "react-number-format";
import useMediaQuery from '@mui/material/useMediaQuery';
import { OpenMode } from "../../../common/Enums";

enum CustomerType {
  NORMAL = 1,
  TRADING = 2
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  })
);

const StyledBox = styled(Box)(({ theme }) => ({
  height: "85%",
  width: "100%",
  "& .MuiDataGrid-cell--editing": {
    backgroundColor: "rgb(255,215,115, 0.19)",
    color: "#1a3e72",
    "& .MuiInputBase-root": {
      height: "100%"
    }
  },
  "& .Mui-error": {
    backgroundColor: `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1
      })`,
    color: theme.palette.error.main
  }
}));

const FakeDataGrid = styled(DataGridPro)(({ theme }) => ({
  "& .MuiDataGrid-columnHeaders": { display: "none" },
  "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" },
  "& .MuiDataGrid-columnFooters": { display: "none" }
}));

const defaultEndUser = { name: "ABLESTICK", value: "4" };

export interface PurchaseOrderSingleHandle {
  Initialise: (mode: OpenMode, purchaseOrder: PurchaseOrder) => void;
}

export function GetPurchaseOrderRegion(poNo: string) {
  return poNo.substring(4, 6);
}

export const PurchaseOrderSingle = React.forwardRef(
  (props: CommonProps, ref: React.Ref<PurchaseOrderSingleHandle>) => {
    const style = { ...useStyles(), ...globalTheme() };

    const tinyScreen = useMediaQuery('(max-width:1366px)');
    const smallScreen = useMediaQuery('(max-width:1920px)');
    const normalScreen = useMediaQuery('(max-width:2560px)');

    const productListModalRef = React.useRef<ProductListHandle>(null);
    const endUserListModalRef = React.useRef<EndUserListHandle>(null);
    const viewerModalRef = React.useRef<PurchaseOrderViewerHandle>(null);
    const customerAddressModalRef = React.useRef<CustomerAddressHandle>(null);
    const customerContactPersonModalRef = React.useRef<CustomerContactPersonHandle>(null);

    const [open, setOpen] = React.useState(false);
    const [openMode, setOpenMode] = React.useState<OpenMode>(OpenMode.NEW);
    const [model, setModel] = React.useState<PurchaseOrder>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [region, setRegion] = React.useState<string>("");
    const [filteredCustomers, setFilteredCustomers] = React.useState<DropDownComboOption[]>([]);
    const [tradingCompanies, setTradingCompanies] = React.useState<DropDownComboOption[]>([]);
    const [showTrading, setShowTrading] = React.useState<boolean>(false);
    const [selectedPurchaseCurrency, setSelectedPurchaseCurrency] = React.useState<string | null>("JPY");
    const [profitMargin, setProfitMargin] = React.useState<string>("");
    const [disablePurchaseCurrency, setDisablePurchaseCurrency] = React.useState<boolean>(true);
    const [isSample, setIsSample] = React.useState<boolean>(false);

    const [disableRegionDropDown, setDisableRegionDropDown] = React.useState<boolean>(true);
    const [disablePreviewButton, setDisablePreviewButton] = React.useState<boolean>(true);
    const [sendToHongKong, setSendToHongKong] = React.useState<boolean>(true);

    const [copyReqDel, setCopyReqDel] = React.useState<string | null>(null);
    const [copyActDel, setCopyActDel] = React.useState<string | null>(null);
    const [copyEndUser, setCopyEndUser] = React.useState<string>("");
    const [copyEndUserId, setCopyEndUserId] = React.useState<number>(0);
    const [copyRegion, setCopyRegion] = React.useState<string>();
    const [copyCustomerPO, setCopyCustomerPO] = React.useState<string>("");
    const [selectedCustomer, setSelectedCustomer] = React.useState<Customer>();
    const [selectedTradingCompany, setSelectedTradingCompany] = React.useState<Customer>();
    const [selectedTradingCompanyOption, setSelectedTradingCompanyOption] = React.useState<DropDownComboOption | null>(null);
    const [labelSendTo, setLabelSendTo] = React.useState<string>(defaultLabelSendTo);

    const [poDeliveryTo, setPoDeliveryTo] = React.useState<string>(deliveryTo);
    const [poDeliveryAddress, setPoDeliveryAddress] = React.useState<string>(deliveryAddress);
    const [poDeliveryAttention, setPoDeliveryAttention] = React.useState<string>(deliveryAttn);
    const [poDeliveryPhone, setPoDeliveryPhone] = React.useState<string>(deliveryPhone);
    const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);

    const [showInvoiceNo, setShowInvoiceNo] = React.useState<string>('hidden');
    const [selectedItem, setSelectedItem] = React.useState<PurchaseOrderItem | null>(null);
    const [selectedItemInvoiceNo, setSelectedItemInvoiceNo] = React.useState<string>("");

    const [decimalPlace, setDecimalPlace] = React.useState<number>(0);

    const [profitMarginErrorText, setProfitMarginErrorText] = React.useState<string>("");
    const [fakeGridData, setFakeGridData] = React.useState<GridRowsProp>([]);

    const [switchPageOnClose, setSwitchPageOnClose] = React.useState<boolean>(false);
    const [saved, setSaved] = React.useState<boolean>(false);

    const columnWidth25 = useMemo(() => GetColumnWidth(25, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth35 = useMemo(() => GetColumnWidth(35, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth40 = useMemo(() => GetColumnWidth(40, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth50 = useMemo(() => GetColumnWidth(50, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth55 = useMemo(() => GetColumnWidth(55, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth60 = useMemo(() => GetColumnWidth(60, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth68 = useMemo(() => GetColumnWidth(68, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth70 = useMemo(() => GetColumnWidth(70, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth80 = useMemo(() => GetColumnWidth(80, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth100 = useMemo(() => GetColumnWidth(100, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth120 = useMemo(() => GetColumnWidth(120, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    function GetColumnWidth(width: number, isTiny: boolean, isSmall: boolean) {
      switch (width) {
        case 25:
          return isTiny ? 25 : (isSmall ? 30 : 35);
        case 35:
          return isTiny ? 35 : (isSmall ? 40 : 45);
        case 40:
          return isTiny ? 40 : (isSmall ? 45 : 55);
        case 50:
          return isTiny ? 50 : (isSmall ? 58 : 68);
        case 55:
          return isTiny ? 55 : (isSmall ? 70 : 80);
        case 60:
          return isTiny ? 60 : (isSmall ? 80 : 90);
        case 68:
          return isTiny ? 68 : (isSmall ? 85 : 100);
        case 70:
          return isTiny ? 70 : (isSmall ? 90 : 105);
        case 80:
          return isTiny ? 80 : (isSmall ? 100 : 110);
        case 100:
          return isTiny ? 100 : (isSmall ? 125 : 150);
        case 120:
          return isTiny ? 120 : (isSmall ? 155 : 190);
        default:
          return width;
      }
    }

    //Grid columns
    const fakeGridColumns: GridColumns = [
      {
        field: 'col1',
        width: columnWidth35+columnWidth50, minWidth: columnWidth35+columnWidth50,
        renderCell: (cellValues) => {
          return (
            <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Add />} onClick={() => AddRow()}>Add</Button>
          );
        }
      },
      {
        field: 'col2',
        width: columnWidth35+columnWidth50, minWidth: columnWidth35+columnWidth50,
        renderCell: () => {
          return (
            <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Delete />} onClick={() => DeleteRows()}>Del</Button>
          );
        }
      },
      {
        field: 'col3',
        width: columnWidth120+columnWidth60*4, minWidth: columnWidth120+columnWidth60*4,
        renderCell: () => {
          const ShowInvoiceNo = () => {
            if (selectedItem)
            {
              let params = { poNo:  selectedItem?.poNo, lotNo: selectedItem?.lotNo};
              axios.get(`Api/V1/PurchaseOrder/Item/SearchInvoice`, {
                params,
                headers: {
                  'Content-Encoding': 'gzip'
                }
              }).then((result) => {
                  setSelectedItemInvoiceNo(result.data);
                  if (result.data)
                  {
                    if (result.data.length>0)
                      setShowInvoiceNo('visible');
                  }
                },
                  (error) => {
                      console.log(error);
                      showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
                  }
              )    
            }
          };
          const HideInvoiceNo = () => {
            setShowInvoiceNo('hidden');
            setSelectedItemInvoiceNo('');
          }
          return (
            <>
              <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} 
                startIcon={<SwitchLeft />} 
                onClick={() => SplitRow()}
                sx={{visibility : selectedItem ? 'visible' : 'hidden'}}>
                Split
              </Button>
              <div style={{ width: 30 }}></div>
              <IconButton
                onMouseEnter={() => {
                    ShowInvoiceNo();
                }}
                onMouseLeave={() => {
                  HideInvoiceNo();
                }}
                sx={{visibility : selectedItem ? 'visible' : 'hidden'}}
              >
              <Info fontSize="large" />
              </IconButton>
              <div style={{ width: tinyScreen ? "calc(100% - 500px)" : (smallScreen ? "calc(100% - 650px)" : "calc(100% - 900px)") }}>
                <Box sx={{ width: 150, borderRadius: 1, border: 1, p: 1, 
                        color: "rgba(12,55,88, 0.95)", bgcolor: "rgba(118,185,237, 0.90)", 
                        visibility: showInvoiceNo, justifyContent: "center" }} display="flex" >
                    <Typography fontWeight="bold">
                      {selectedItemInvoiceNo}
                    </Typography>
                </Box>
              </div>
            </>
          );
        }
      },
      { 
        field: 'col4', 
        width: columnWidth40, minWidth: columnWidth40,
        editable: false,
        renderCell: (cellValues) => {
          return (
            <>
            <div style={{ width: '100%' }}></div>
            <IconButton
              onClick={(event) => {
                CopyValues();
              }}
            >
              <ContentCopy />
            </IconButton>
            </>
          );
        }
      },
      {
        field: 'reqDel', headerName: 'Req. Del.', disableColumnMenu: true, sortable: false,
        width: columnWidth80, minWidth: columnWidth80,
        type: 'date', editable: true,
        renderEditCell: (cellValues) => {
          return (
            <TextField
              value={copyReqDel}
              onChange={(e) => {
                SetDate("Req", e.target.value);
              }}
              variant="standard"
              InputProps={{
                disableUnderline: true
              }}
              fullWidth
              label="Req. Del."
              style={{ marginLeft: "9px" }}
            >
            </TextField>
          );
        },
        renderCell: (cellValues) => {
          return (
            <TextField
              value={copyReqDel}
              variant="standard"
              InputProps={{
                disableUnderline: true
              }}
              fullWidth
              label="Req. Del."
            >
            </TextField>
          );
        }
      },
      {
        field: 'actDel', headerName: 'Act. Del.', disableColumnMenu: true, sortable: false,
        width: columnWidth80, minWidth: columnWidth80, 
        type: 'string', editable: true,
        renderEditCell: (cellValues) => {
          return (
            <TextField
              value={copyActDel}
              onChange={(e) => {
                SetDate("Act", e.target.value);
              }}
              variant="standard"
              InputProps={{
                disableUnderline: true
              }}
              fullWidth
              label="Act. Del."
              style={{ marginLeft: "9px" }}
            >
            </TextField>
          );
        },
        renderCell: (cellValues) => {
          return (
            <TextField
              value={copyActDel}
              variant="standard"
              InputProps={{
                disableUnderline: true
              }}
              fullWidth
              label="Act. Del."
            >
            </TextField>
          );
        }
      },
      {
        field: 'endUser', flex: 5, editable: false,
        renderCell: (cellValues) => {
          return (
            <TextField
              variant="standard"
              label="End User"
              value={copyEndUser}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" sx={{ visibility: copyEndUser ? "visible" : "hidden" }}
                      onClick={() => { 
                          setCopyEndUser("");
                          setCopyEndUserId(0);
                        }
                      }
                    >
                      <Clear />
                    </IconButton>
                    <IconButton size="small"
                      onClick={() => { endUserListModalRef.current?.Initialise(); }
                      }
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          );
        },
        renderEditCell: (cellValues) => {
          return (
            <TextField
              variant="standard"
              label="End User"
              value={copyEndUser}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" sx={{ visibility: copyEndUser ? "visible" : "hidden" }}
                      onClick={() => { 
                        setCopyEndUser("");
                        setCopyEndUserId(0);
                        }
                      }
                    >
                      <Clear />
                    </IconButton>
                    <IconButton
                      onClick={() => { endUserListModalRef.current?.Initialise(); }
                      }
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          );
        }
      },
      {
        field: 'region', headerName: 'Region', disableColumnMenu: true, sortable: false,
        flex: 2, editable: true,
        renderCell: (cellValues) => {
          return (
            <TextField
              value={copyRegion}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setCopyRegion(event.target.value);
              }}
              variant="standard"
              InputProps={{
                disableUnderline: true
              }}
              fullWidth
              select
              label="Region"
            >
              {props.regions.map((item) => (
                <MenuItem key={item.name} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          );
        }
      },
      {
        field: 'copyCustomerPO', flex: 3, editable: true, align: 'right',
        renderEditCell: (cellValues) => {
          return (
            <TextField
              value={copyCustomerPO}
              onChange={(e) => {
                setCopyCustomerPO(e.target.value)
              }}
              variant="standard"
              InputProps={{
                disableUnderline: true
              }}
              fullWidth
              label="Customer PO"
              style={{ marginLeft: "9px" }}
            >
            </TextField>
          );
        },
        renderCell: (cellValues) => {
          return (
            <TextField
              value={copyCustomerPO}
              variant="standard"
              InputProps={{
                disableUnderline: true
              }}
              fullWidth
              label="Customer PO"
            >
            </TextField>
          );
        }
      },
      { field: 'col5', flex: 6, editable: false },
      { field: 'col6', width: columnWidth120, minWidth: columnWidth120, editable: false },
      { field: 'col7', flex: 5, editable: false }
    ];

    const renderSelectEditInputCell: GridColDef['renderCell'] = (params) => {
      return <SelectEditInputCell {...params} />;
    };

    const [gridData, setGridData] = React.useState<PurchaseOrderItem[]>([]);
    //Grid columns
    const columns: GridColumns = [
      {
        field: 'seq', headerName: 'No.', disableColumnMenu: true,
        width: columnWidth40, minWidth: columnWidth40,
        type: 'number', editable: true, align: 'right',
        valueSetter: (param: GridValueSetterParams) => onSeqChanged(param),
        preProcessEditCellProps: validateSeqChanged,
        cellClassName: style.NumberTextField
      },
      { 
        field: 'model', headerName: '型式', editable: true, 
        width: columnWidth120, minWidth: columnWidth120,
        type: 'string' 
      },
      {
        field: 'productCode', headerName: '商品CD', disableColumnMenu: true, sortable: false, editable: true,
        width: columnWidth120, minWidth: columnWidth120, type: 'string'
      },
      {
        field: 'qty', headerName: '数量', disableColumnMenu: true, sortable: false,
        width: columnWidth50, minWidth: columnWidth50,
        type: 'number', editable: true, align: 'right',
        valueSetter: onQtyChanged,
        preProcessEditCellProps: validateQtyChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'price', headerName: '標準価格', disableColumnMenu: true, sortable: false,
        width: columnWidth60, minWidth: columnWidth60,
        type: 'number'
      },
      {
        field: 'purchasePercent', headerName: 'Buy%', disableColumnMenu: true, sortable: false,
        width: columnWidth60, minWidth: columnWidth60,
        type: 'number', editable: true, align: 'right',
        valueFormatter: (param) => FormatNumber(param.value, 5),
        valueSetter: onPurchasePercentageChanged,
        preProcessEditCellProps: validateNumberValueChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'purchasePrice', headerName: 'Buy @Price', disableColumnMenu: true, sortable: false,
        width: columnWidth70, minWidth: columnWidth70,
        type: 'number', editable: true, align: 'right',
        valueGetter: (param) => FormatNumber(param.row.purchasePrice, 0),
        valueSetter: onPurchasePriceChanged,
        preProcessEditCellProps: validateNumberValueChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'sellingPercent', headerName: 'Sell%', disableColumnMenu: true, sortable: false,
        width: columnWidth60, minWidth: columnWidth60,
        type: 'number', editable: true, align: 'right',
        valueFormatter: (param) => FormatNumber(param.value, 5),
        valueSetter: onSellingPercentChanged,
        preProcessEditCellProps: validateNumberValueChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'euPrice', headerName: 'EU Price', disableColumnMenu: true, sortable: false,
        width: columnWidth60, minWidth: columnWidth60,
        type: 'number', editable: true, align: 'right',
        valueGetter: (param) => FormatNumber(param.row.euPrice, param.row.decimalPlace ?? 2),
        valueSetter: onEuPriceChanged,
        preProcessEditCellProps: validateNumberValueChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'reqDel', headerName: 'Req. Del.', disableColumnMenu: true, sortable: false,
        width: columnWidth68, minWidth: columnWidth68,
        type: 'string', editable: true,
        valueSetter: onReqDelChanged,
        preProcessEditCellProps: validateDateChanged
      },
      {
        field: 'actDel', headerName: 'Act. Del.', disableColumnMenu: true, sortable: false,
        width: columnWidth68, minWidth: columnWidth68,
        type: "string", editable: true,
        valueSetter: onActDelChanged,
        preProcessEditCellProps: validateDateChanged
      },
      {
        field: 'endUser', headerName: 'End User', disableColumnMenu: true, sortable: false,
        width: columnWidth80, minWidth: columnWidth80,
        type: 'string', editable: true,
        valueSetter: onEndUserChanged,
        preProcessEditCellProps: validateEndUserChanged
      },
      {
        field: 'region', headerName: 'Region', disableColumnMenu: true, sortable: false,
        width: columnWidth50, minWidth: columnWidth50,
        editable: true, headerAlign: "center", align: "center",
        renderEditCell: renderSelectEditInputCell
      },
      {
        field: 'customerPO', headerName: '顧客のPO#', disableColumnMenu: true, sortable: false,
        width: columnWidth100, minWidth: columnWidth100,
        type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "customerPO", 30)
      },
      {
        field: 'partNo', headerName: 'Part No.', disableColumnMenu: true, sortable: false,
        flex: 3, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "partNo", 20),
      },
      {
        field: 'discountCode', headerName: '特值號', disableColumnMenu: true, sortable: false,
        flex: 3, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "discountCode", 25),
      },
      {
        field: 'productDesc', headerName: '製品名',
        minWidth: columnWidth120,
        flex: 8, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "productDesc", 150),
      },
      {
        field: 'unit', headerName: '单位', disableColumnMenu: true, sortable: false,
        width: columnWidth40, minWidth: columnWidth40,
        type: 'string'
      },
      {
        field: 'description', headerName: '針長', disableColumnMenu: true, sortable: false,
        flex: 3, type: 'string'
      },
      {
        field: 'minOrderQty', headerName: '最少数', disableColumnMenu: true, sortable: false,
        width: columnWidth50, minWidth: columnWidth50,
        type: 'number'
      }
    ];

    const [searchData, setSearchData] = React.useState<any>({
      pageSize: 10,
    });

    const selectedData = React.useRef<PurchaseOrderItem[]>([]);

    function SetDate(dateType: string, input: string)
    {
      let valid = false;
      if (input.length==10)
      {
        if (moment(input, "YYYY/MM/DD", true).isValid())
          valid = true;
        else
          showSnackBar("Date must be yyyy/mm/dd", "", "error");
      }
      else
      {
        if (input.length>10)
          showSnackBar("Date must be yyyy/mm/dd", "", "error");

      }

      if (dateType=="Req")
        valid ? setCopyReqDel(input) : setCopyReqDel(null);
      else if (dateType=="Act")
        valid ? setCopyActDel(input) : setCopyActDel(null);
    }

    function CopyValues() {
      let tempGridData = [...gridData];
      tempGridData.forEach(x => {
        if (x.reqDel)
          x.reqDel = (copyReqDel == null || copyReqDel == "") ? "" : moment(x.reqDel).format("YYYY/MM/DD");
        else
          x.reqDel = copyReqDel ?? "";

        if (x.actDel)
          x.actDel = (copyActDel == null || copyActDel == "") ? "" : moment(x.actDel).format("YYYY/MM/DD");
        else
          x.actDel = copyActDel ?? "";

        if (x.endUser) {
          if (copyEndUserId == 0) {
            x.endUser = "";
            x.endUserID = 0;
          }
        }
        else {
          x.endUser = copyEndUser;
          x.endUserID = copyEndUserId;
        }

        x.region = copyRegion ?? "";

        if (x.customerPO) {
          if (!copyCustomerPO || copyCustomerPO == "")
            x.customerPO = "";
        }
        else {
          x.customerPO = copyCustomerPO ?? "";
        }

      })
      setGridData(tempGridData);
      hasChanges.current = true;
    }

    function SelectEditInputCell(selectProps: GridRenderCellParams) {
      const { id, value, field } = selectProps;
      const apiRef = useGridApiContext();

      const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        let tempGridData = [...gridData];

        let index = tempGridData.findIndex(x => x.id === id);
        if (index > -1) {
          tempGridData[index].region = event.target.value;
          setGridData(tempGridData);
          hasChanges.current = true;
        }

        await apiRef.current.setEditCellValue({ id, field, value: event.target.value });
        apiRef.current.setCellMode(id, field, 'view');
      };

      return (
        <TextField
          value={value}
          onChange={handleChange}
          variant="standard"
          InputProps={{
            disableUnderline: true,
            style: { fontSize: 13 }
          }}
          select
        >
          {props.regions.map((item) => (
            <MenuItem key={item.name} value={item.value}>
              {item.name}
            </MenuItem>
          ))}
        </TextField>
      );
    }

    function onCellValueChanged(param: GridValueSetterParams, field: string, maxLength: number) {
      renewToken();
      let row: PurchaseOrderItem = param.row;
      Object.entries(row).forEach(([key, value]) => {
        if (`${key}` === field) {
          if (maxLength > 0)
            Reflect.set(row, key, param.value.slice(0, maxLength));
          else
            Reflect.set(row, key, param.value);
        }
      });

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      Object.entries(tmpData[index]).forEach(([key, value]) => {
        if (`${key}` === `${field}`) {
          if (maxLength > 0)
            Reflect.set(tmpData[index], key, param.value.slice(0, maxLength));
          else
            Reflect.set(tmpData[index], key, param.value);
        }
      });
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onSeqChanged(param: GridValueSetterParams) {
      let row: PurchaseOrderItem = param.row;
      let tempGridData = [...gridData];  
      let index = tempGridData.findIndex(x => x.id === row.id);
      let duplicatedRowIndex = tempGridData.findIndex(x => x.seq == param.value);
      if (duplicatedRowIndex > -1)
      {
        //swap sequence no.
        tempGridData[duplicatedRowIndex].seq = tempGridData[index].seq;
      }

      tempGridData[index].seq = param.value;
      setGridData(tempGridData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function validateSeqChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.INTEGER, true);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }

    function validateQtyChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.INTEGER, true);

      if (openMode === OpenMode.EDIT && ((param.row.qty !== param.row.osQty) && (parseInt(param.props.value) > param.row.osQty))) {
        errMsg = "This item is partially shipped, the maximum value allowed is " + param.row.osQty.toString();
      }

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }

    function validateNumberValueChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.FLOAT, false);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }

    function onQtyChanged(param: GridValueSetterParams) {
      let row: PurchaseOrderItem = param.row;
      row.osQty = param.value;
      row.qty = param.value;

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].osQty = row.osQty;
      tmpData[index].qty = row.qty;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function validateDateChanged(param: GridPreProcessEditCellProps) {
      let invalid: boolean = false;
      let errMsg: string = "";

      if (param.props.value.length==10)
      {
        if (isNaN(Date.parse(param.props.value)))
        {
          invalid = true;
          errMsg = "Date must be yyyy/mm/dd";
        }
        else
        {
          if (param.props.value.substring(4,5)!="/" || param.props.value.substring(7,8)!="/")
          {
            invalid = true;
            errMsg = "Date must be yyyy/mm/dd";
          }
          else
          {
            invalid = false;
          }
        }
      }
      else
      {
        if (param.props.value.length>0)
        {
          invalid = true;
          errMsg = "Date must be yyyy/mm/dd";
        }
        else
        {
          invalid = false;
        }
      }

      if (invalid)
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: invalid };
    }

    function validateEndUserChanged(param: GridPreProcessEditCellProps) {
      let invalid: boolean = false;
      let errMsg: string = "";
      if (props.endUsers.findIndex(x => x.endUserName.trim() === param.props.value || x.endUserEng.trim() === param.props.value) === -1 && param.props.value != "") {
        invalid = true;
        errMsg = "End user not found!";
      }

      if (invalid)
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: invalid };
    }

    function onPurchasePercentageChanged(param: GridValueSetterParams) {
      let row: PurchaseOrderItem = param.row;
      row.purchasePercent = parseFloat(param.value.toString().replace(/,/g, ''));
      row.purchasePrice = AwayFromZeroRounding(parseFloat((row.price ?? 0).toFixed(5)) * row.purchasePercent / 100, 0);

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].purchasePercent = row.purchasePercent;
      tmpData[index].purchasePrice = row.purchasePrice;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onPurchasePriceChanged(param: GridValueSetterParams) {
      let row: PurchaseOrderItem = param.row;
      row.purchasePrice = parseFloat(param.value.toString().replace(/,/g, ''));
      if (row.price && row.price > 0)
        row.purchasePercent = AwayFromZeroRounding(row.purchasePrice / row.price * 100, 1);

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].purchasePercent = row.purchasePercent;
      tmpData[index].purchasePrice = row.purchasePrice;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onSellingPercentChanged(param: GridValueSetterParams) {
      let row: PurchaseOrderItem = param.row;
      row.sellingPercent = parseFloat(param.value.toString().replace(/,/g, ''));
      row.euPrice = AwayFromZeroRounding((model?.exRate ?? 1) * (row.price ?? 0) * parseFloat(param.value.toString().replace(/,/g, '')) / 100, row.decimalPlace);

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].sellingPercent = row.sellingPercent;
      tmpData[index].euPrice = row.euPrice;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onEuPriceChanged(param: GridValueSetterParams) {
      let row: PurchaseOrderItem = param.row;
      row.euPrice = parseFloat(param.value.toString().replace(/,/g, ''));
      if (row.price && row.price > 0)
        row.sellingPercent = AwayFromZeroRounding(row.euPrice / (model?.exRate ?? 1) / row.price * 100, 5);

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].sellingPercent = row.sellingPercent;
      tmpData[index].euPrice = row.euPrice;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onReqDelChanged(param: GridValueSetterParams) {
      let row: PurchaseOrderItem = param.row;
      row.reqDel = param.value;

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].reqDel = param.value;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onActDelChanged(param: GridValueSetterParams) {
      let row: PurchaseOrderItem = param.row;
      row.actDel = param.value;

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].actDel = param.value;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onEndUserChanged(param: GridValueSetterParams) {
      let row: PurchaseOrderItem = param.row;
      let rowIndex = props.endUsers.findIndex(x => x.endUserName.trim() === param.value || x.endUserEng.trim() === param.value);
      if (param.value == '')
      {
        row.endUser = param.value;
        row.endUserID = 0;
      }
      else
      {
        row.endUser = param.value;
        row.endUserID = props.endUsers[rowIndex].endUserId;

        let tmpData = gridData;
        let index = tmpData.findIndex(x => x.id === row.id);
        tmpData[index].endUser = row.endUser;
        tmpData[index].endUserID = row.endUserID;
        setGridData(tmpData);
      }

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function CalculateProfitMargin() {
      let sum1 = 0.0;
      let sum2 = 0.0;
      let tempData = [...gridData];
      tempData.forEach(x => {
        sum1 += ((x.euPrice / (model?.exRate ?? 1)) - x.purchasePrice) * x.qty;
        sum2 += x.purchasePrice * x.qty;
      })

      return sum1 / sum2;
    }

    function SendToHongKongChanged(event: React.ChangeEvent<HTMLInputElement>) {
      setSendToHongKong(event.target.checked);
      if (selectedTradingCompany && selectedTradingCompany.customerId > 0) {
        UpdateDeliveryInfo(event.target.checked, region, selectedTradingCompany);
      }
      else {
        UpdateDeliveryInfo(event.target.checked, region, selectedCustomer);
      }
    }

    function AddRow() {
      productListModalRef.current?.Initialise();
    }

    function DeleteRows() {
      if (selectedData.current.length == 0)
      {
        return;
      }
      let tempGridData = [...gridData];
      selectedData.current.forEach(item => {
        let index = tempGridData.findIndex(x => x.lotNo === item.lotNo);
        if (index > -1) {
          tempGridData.splice(index, 1);
        }
      });
      let i = 1;
      tempGridData.forEach(x => {
        x.id = i;
        x.lotNo = i;
        x.seq = i;
        i++
      })
      setGridData(tempGridData);
      let temp = model;
      if (temp) {
        temp.purchaseOrderItems = tempGridData;
      }
      setModel(temp);
      setSelectionModel([])
      selectedData.current = [];
    }

    function SplitRow()
    {
      if (selectedItem)
      {
        let selected = {...selectedItem};
        let newGridData: PurchaseOrderItem[] = [];
        let tempGridData = [...gridData];
          tempGridData.forEach(item => {
            if (item.lotNo<selected.lotNo)
            {
              newGridData.push({...item});  
            }
            else if (item.lotNo==selected.lotNo)
            {
              newGridData.push({...item});  
              let newItem = {...item};
              newItem.id = item.id + 1;
              newItem.lotNo = item.lotNo + 1;
              newItem.seq = (item.seq ?? 0) + 1;
              newGridData.push(newItem);  
            }
            else if (item.lotNo>selected.lotNo)
            {
              let newItem = {...item};
              newItem.id = item.id + 1;
              newItem.lotNo = item.lotNo + 1;
              newItem.seq = (item.seq ?? 0) + 1;
              newGridData.push(newItem);  
            }
          });
        setGridData(newGridData);
        let temp = model;
        if (temp) {
          temp.purchaseOrderItems = tempGridData;
        }
        setModel(temp);
      }
    }

    function AddCustomerAddress() {
      if (selectedCustomer)
        customerAddressModalRef.current?.Initialise(selectedCustomer.customerId);
    }

    function AddCustomerContactPerson() {
      if (selectedCustomer)
        customerContactPersonModalRef.current?.Initialise(selectedCustomer.customerId);
    }

    //Dialogs and snacks
    const hasChanges = React.useRef<boolean>(false);
    const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
    const [snackSettings, setSnackSettings] =
      React.useState<SnackBarMessageProps>({
        open: false,
        message: "",
        subMessage: "",
        severity: undefined,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => { } })
      });

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
      setSnackSettings({
        open: true,
        message: message,
        subMessage: subMessage,
        severity: colour,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => { } })
      });
    }

    useImperativeHandle(ref, () => ({
      Initialise(mode: OpenMode, purchaseOrder: PurchaseOrder) {
        setOpen(true);
        setSelectedItem(null);
        setSaved(false);
        renewToken();

        hasChanges.current = false;
        setOpenMode(mode);
        setCopyCustomerPO("");
        setCopyEndUser(purchaseOrder.endUser ?? "");
        setCopyEndUserId(purchaseOrder.endUserID ?? 0);
        setCopyReqDel(null);
        setCopyActDel(null);

        let poRegion: string = GetPurchaseOrderRegion(purchaseOrder.poNo);

        LoadTradingCompanies((purchaseOrder.tradingCompanyID ?? 0) + purchaseOrder.custLangID * 100000, poRegion);

        setLabelSendTo(sendTo.find(x => x.Region === poRegion)?.Label ?? defaultLabelSendTo);
        setProfitMargin("");
        FilterCustomersByLanguage([0]); //Always show customer names of any language
        if (mode === OpenMode.NEW) {
          FilterCustomersByLanguage([0]);
          setRegion(poRegion);
          setIsSample(purchaseOrder.isSample);
          setCopyRegion(poRegion);
          setDisableRegionDropDown(false);
          setDisablePreviewButton(true);
        }
        else if (mode === OpenMode.EDIT) {
          setRegion(poRegion);
          setCopyRegion(poRegion);
          setDisableRegionDropDown(true);
          setDisablePreviewButton(false);
          purchaseOrder.purchaseOrderItems.forEach(i => {
            i.id = i.lotNo;
            if (!i.customerPO)
              i.customerPO = "";
          });

          LoadCustomerInfo(CustomerType.NORMAL, purchaseOrder.customerID, purchaseOrder.custLangID, purchaseOrder.customerName, true);
          LoadCustomerInfo(CustomerType.TRADING, purchaseOrder.tradingCompanyID ?? 0, purchaseOrder.custLangID, purchaseOrder.customerName, true);
        }
        else if (mode === OpenMode.COPY) {
          setRegion(poRegion);
          setCopyRegion(poRegion);
          setIsSample(purchaseOrder.isSample);
          setDisableRegionDropDown(false);
          setDisablePreviewButton(true);
          setSwitchPageOnClose(true);

          purchaseOrder.purchaseOrderItems.forEach(i => {
            i.id = i.lotNo;
            i.purchasePercent = AwayFromZeroRounding(i.purchasePrice / (i.price ?? 1) * 100, 1);
            if (!i.customerPO)
              i.customerPO = "";
          });

          LoadCustomerInfo(CustomerType.NORMAL, purchaseOrder.customerID, purchaseOrder.custLangID, purchaseOrder.customerName, true);
          LoadCustomerInfo(CustomerType.TRADING, purchaseOrder.tradingCompanyID ?? 0, purchaseOrder.custLangID, purchaseOrder.customerName, true);
        }
        setPoDeliveryAttention(purchaseOrder.deliveryAttention);
        setPoDeliveryAddress(purchaseOrder.deliveryAddress);
        setPoDeliveryTo(purchaseOrder.deliveryTo);
        setPoDeliveryPhone(purchaseOrder.deliveryPhone);

        if (purchaseOrder.deliveryTo === deliveryTo || purchaseOrder.deliveryTo === deliveryToSS)
          setSendToHongKong(true);
        else
          setSendToHongKong(false);

        let temp: any = { ...model };
        temp = purchaseOrder;
        if (props.paymentTerms.findIndex(x => x.name === temp.paymentTerm) > -1)
          temp.paymentTerm = temp.paymentTerm;
        else
          temp.paymentTerm = defaultPaymentTerm;
        temp.mobile = "";
        temp.email = "";
        temp.loginName = "";
        temp.isPaid = false;
        temp.isAPGenerated = false;
        temp.manufacturerAddress = "";
        temp.purchaseOrderItems.forEach((x: PurchaseOrderItem) => {
          x.decimalPlace = purchaseOrder.currency=='JPY' ? 0 : 2;
        });
        setModel(temp);

        setDecimalPlace(purchaseOrder.currency=='JPY' ? 0 : 2);

        setFakeGridData([{ id: "1", region: poRegion }])
        setGridData(purchaseOrder.purchaseOrderItems);
      },
    }));

    function closeDialog() {
      setDialogOpen(false);
      setOpen(false);
      props.onClose(false, model!);
    }

    function closeModalCheck(keepOpen: boolean) { // Use keepOpen to prevent closing by Esc
      if (hasChanges.current) {
        setDialogOpen(true);
      } else {
        setDialogOpen(false);
        setOpen(keepOpen);
        props.onClose(switchPageOnClose && saved, model!);
      }
    }

    function isSaveValid(showWarning: boolean) {
      let proceed = true;
      let warning = "";
      let noOfLines = 0;
      if (model) {
        if (model.purchaseOrderItems) {
          let newLotNos = model.purchaseOrderItems.map(item => item.seq);
          if (HasDuplicates(newLotNos)) {
            warning += "Duplicated \'No\' found in purchase order items\r\n";
            noOfLines++;
            proceed = false;
          }
        }

        if (model.customerName === "" || model.customerID === 0) {
          warning += "Please select a customer\r\n"
          noOfLines++;
          proceed = false
        }

        if (model.staff === "" || model.staffID === 0) {
          warning += "Please select a staff\r\n"
          noOfLines++;
          proceed = false
        }

        if (model.customerPO === "") {
          warning += "Please enter a customer PO #\r\n"
          noOfLines++;
          proceed = false
        }

        if (!proceed && showWarning) {
          showSnackBar(warning.toString(), "", "error");
        }
      }

      return proceed;
    }

    function Update(
      propertyName: string,
      propertyValue: any,
      validationRegex?: RegExp
    ) {
      let proceed = true;

      if (validationRegex !== undefined) {
        proceed = validationRegex.test(propertyValue);
      }

      if (proceed) {
        let temp: any = { ...model };

        if (temp[propertyName] != propertyValue) {
          hasChanges.current = true;
          temp[propertyName] = propertyValue ?? null;
          setModel(temp);
        }
      }
    }

    function CustomerChanged(newCustomer: any) {
      if (newCustomer) {
        let custId = newCustomer.value % 100000;
        let custLangId = Math.trunc(newCustomer.value / 100000);
        LoadCustomerInfo(CustomerType.NORMAL, custId, custLangId, newCustomer.name, false);
      }
    }

    function SelectedCustomerChanged(type: CustomerType, custId: number, custLangId: number, custName: string, cust: Customer) {
      let temp: any = { ...model };
      if (type === CustomerType.NORMAL) {
        temp.customerID = custId;
        temp.customerName = custName;
        temp.custLangID = custLangId;
      }
      else {
        temp.tradingCompanyID = custId;
        temp.tradingCompany = custName;
      }
      if (props.paymentTerms.findIndex(x => x.name === cust.paymentTerm) > -1)
        temp.paymentTerm = cust.paymentTerm;
      else
        temp.paymentTerm = defaultPaymentTerm;

      setModel(temp);
      hasChanges.current = true;
    }

    function UpdateDeliveryInfo(sendToHongKong: boolean, region: string, cust: Customer | undefined) {
      if (sendToHongKong) {
        if (region === "SS") {
          setPoDeliveryAttention(deliveryAttnSS);
          setPoDeliveryPhone(deliveryPhoneSS);
          setPoDeliveryTo(deliveryToSS);
          setPoDeliveryAddress(deliveryAddressSS);
        }
        else {
          setPoDeliveryAttention(deliveryAttn);
          setPoDeliveryPhone(deliveryPhone);
          setPoDeliveryTo(deliveryTo);
          setPoDeliveryAddress(deliveryAddress);
        }
      }
      else {
        if (cust) {
          setPoDeliveryTo(GetCustomerName(cust));
          if (cust.deliveryAddress)
            setPoDeliveryAddress(cust.deliveryAddress);
          else
            setPoDeliveryAddress(cust.address ?? "");

          setPoDeliveryAttention(cust.contactPerson ?? "");
          setPoDeliveryPhone(cust.phone1 ?? "");
        }
      }
      hasChanges.current = true;
    }

    function LoadCustomerInfo(type: CustomerType, customerId: number, custLangId: number, custName: string, isInit: boolean) {
      axios.get<Customer>('Api/V1/Customer/' + customerId.toString(), {
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          if (result.data) {
            if (type === CustomerType.TRADING)
              setSelectedTradingCompany(result.data);
            else
              setSelectedCustomer(result.data);

            if (!isInit) {
              SelectedCustomerChanged(type, customerId, custLangId, custName, result.data);
              if (type === CustomerType.TRADING || (type === CustomerType.NORMAL && !(selectedTradingCompany && selectedTradingCompany?.customerId > 0))) {
                UpdateDeliveryInfo(sendToHongKong, region, result.data);
              }
            }
          }
        },
          (error) => {
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        )
        .catch((error) => {
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });
    }

    function TradingCompanyChanged(newTradingCompany: any, reason: string) {
      if (reason === 'clear') {
        setSelectedTradingCompanyOption(null);
        UpdateDeliveryInfo(sendToHongKong, region, selectedCustomer)
      }
      else {
        if (model) {
          let selectedOption = tradingCompanies?.find(s => s.value === newTradingCompany.value);
          if (selectedOption) {
            setSelectedTradingCompanyOption(selectedOption || null);
          }
          else {
            for (let i = 1; i < 4; i++) {
              selectedOption = tradingCompanies?.find(s => s.value === (newTradingCompany.value % 100000 + i * 100000).toString());
              if (selectedOption) {
                setSelectedTradingCompanyOption(selectedOption || null);
                break;
              }
            }
          }
        }
        else {
          setSelectedTradingCompanyOption(null);
        }

        if (newTradingCompany) {
          let tradingCompanyId = newTradingCompany.value % 100000;
          let langId = Math.trunc(newTradingCompany.value / 100000);
          LoadCustomerInfo(CustomerType.TRADING, tradingCompanyId, langId, newTradingCompany.name, false);
        }
      }
    }

    function LanguageChanged(langId: number) {
      hasChanges.current = true;
      let custLangIds = GetCustLangIdsByLanguageId(langId);
      let temp: any = { ...model };
      let availableCustomerLanguageIds: number[] = [];

      for (var i = 1; i <= 3; i++) {
        let index = props.customers.findIndex(s => s.value === ((temp.customerID ?? 1) + i * 100000).toString());
        if (index > 0) {
          availableCustomerLanguageIds.push(i);
        }
      }

      let commonLangIds: number[] = custLangIds.filter(function (id) {
        return availableCustomerLanguageIds.indexOf(id) > -1;
      });

      if (commonLangIds.length == 0) {
        commonLangIds = availableCustomerLanguageIds;
      }

      let originalId = commonLangIds.find(x => x == model?.custLangID) ?? commonLangIds[0];
      temp.custLangID = originalId;
      temp.customerName = filteredCustomers.find(s => s.value === ((model?.customerID ?? 1) + originalId * 100000).toString())?.name;
      temp.languageID = langId;
      switch(langId)
      {
        case 1:
          temp.purchaseOrderItems.forEach((x: PurchaseOrderItem) => {
            x.productDesc = x.nameEng ?? "";
          });
          break;
        case 2:
          temp.purchaseOrderItems.forEach((x: PurchaseOrderItem) => {
            x.productDesc = x.nameJpn ?? "";
          });
          break;
        case 3:
          temp.purchaseOrderItems.forEach((x: PurchaseOrderItem) => {
            x.productDesc = x.nameChi ?? "";
          });
          break;
        case 4:
          temp.purchaseOrderItems.forEach((x: PurchaseOrderItem) => {
            x.productDesc = ((x.nameEng ?? "") + "  " + (x.nameChi ?? "")).slice(0,80);
          });
          break;
        case 5:
          temp.purchaseOrderItems.forEach((x: PurchaseOrderItem) => {
            x.productDesc = ((x.nameEng ?? "") + "  " + (x.nameJpn ?? "")).slice(0,80);
          });
          break;
        case 6:
          temp.purchaseOrderItems.forEach((x: PurchaseOrderItem) => {
            x.productDesc = ((x.nameChi ?? "") + "  " + (x.nameJpn ?? "")).slice(0,80);
          });
          break;          
      }
      setModel(temp);

      FilterCustomersByLanguage([0])
    }

    function FilterCustomersByLanguage(langIds: number[]) {
      let temp: DropDownComboOption[] = props.customers;
      let result: DropDownComboOption[] = [];
      if (langIds.findIndex(x => x === 0) > -1) {
        setFilteredCustomers(props.customers);
      }
      else {
        langIds.forEach((id) => {
          result = result.concat(Object.values(temp).filter(c => Math.trunc(parseInt(c.value) / 100000) === id));
        });
        setFilteredCustomers(result);
      }
    }

    function RegionChanged(region: string) {
      hasChanges.current = true;

      axios.get<BranchInfo[]>(`Api/V1/Branch`, {
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          let branchSelected: BranchInfo | undefined = result.data.find(b => b.region === region);
          setRegion(region);
          if (branchSelected) {
            let temp: any = { ...model };
            let newPurchaseOrderNo: string = isSample ? "PO" + branchSelected.japanYear + branchSelected.region + "SM" + Pad(branchSelected.samplePONo, 3) : "PO" + branchSelected.japanYear + branchSelected.region + Pad(branchSelected.poNo, 5);
            temp.poNo = newPurchaseOrderNo;
            setModel(temp);
            setLabelSendTo(sendTo.find(x => x.Region === region)?.Label ?? defaultLabelSendTo);
            UpdateDeliveryInfo(sendToHongKong, region, selectedCustomer);
            if (branchSelected.region.trimEnd() === region && branchSelected.tradingCompanyRequired)
              setShowTrading(true);
            else {
              setShowTrading(false);
              setSelectedTradingCompany(undefined);
            }
          }

        },
          (error) => {
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        )
        .catch((error) => {
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });
    }

    function CurrencyChanged(ccy: string) {
      hasChanges.current = true;
      let temp: any = { ...model };
      let exRate = props.currencies.find(c => c.name === ccy)?.value;
      temp["currency"] = ccy;
      temp["exRate"] = Number(exRate);
      var dp = ccy=='JPY' ? 0 : 2;
      setDecimalPlace(dp);
      temp.purchaseOrderItems.forEach((x: PurchaseOrderItem) => {
        x.decimalPlace = dp;
        if ((x.price ?? 0) > 0)
          x.euPrice = AwayFromZeroRounding(Number(exRate) * (x.price ?? 0) * x.sellingPercent / 100, dp);
      });
      setModel(temp);

      let tmpData = gridData;
      tmpData.forEach((x: PurchaseOrderItem) => {
        x.decimalPlace = dp;
        if ((x.price ?? 0) > 0)
          x.euPrice = AwayFromZeroRounding(Number(exRate) * (x.price ?? 0) * x.sellingPercent / 100, dp);
      });

      setGridData(tmpData);
    }

    function ExRateChanged(exrate: string) {
      hasChanges.current = true;

      let msg = ValidateNumber(exrate, NumberTypes.FLOAT, true);
      if (msg === "") {
        let temp: any = { ...model };
        temp["exRate"] = exrate;

        temp.purchaseOrderItems.forEach((x: PurchaseOrderItem) => {
          if ((x.price ?? 0) > 0) {
            x.euPrice = AwayFromZeroRounding(parseFloat(exrate) * (x.price ?? 0) * x.sellingPercent / 100, decimalPlace);
          }
        });
        setModel(temp);
        setGridData([...temp.purchaseOrderItems]);
      }
    }

    function LoadTradingCompanies(tradingCompanyId: number, region: string) {
      setLoading(true);
      axios.all([
        axios.get<any[]>('Api/V1/Customer/Combo/Trading', {
          headers: {
            'Content-Encoding': 'gzip'
          }
        }),
        axios.get<BranchInfo[]>(`Api/V1/Branch`, {
          headers: {
            'Content-Encoding': 'gzip'
          }
        })
      ]).then(axios.spread((...responses) => {
        const tradingCompanyComboResult: AxiosResponse<CustomerCombo[]> = responses[0];
        let loadedTradingCompanies: DropDownComboOption[] = [];
        tradingCompanyComboResult.data.map(c => loadedTradingCompanies.push({ name: c.companyName, value: c?.customerId.toString() }));
        setTradingCompanies(loadedTradingCompanies);
        if (tradingCompanyId % 100000 > 0) {
          setSelectedTradingCompanyOption(loadedTradingCompanies?.find(s => s.value === tradingCompanyId.toString()) || null);
        }
        else {
          setSelectedTradingCompanyOption(null);
        }

        const branchInfoResult: AxiosResponse<BranchInfo[]> = responses[1];
        let branchSelected: BranchInfo | undefined = branchInfoResult.data.find(b => b.region === region);
        if (branchSelected) {
          if (branchSelected.region.trimEnd() === region && branchSelected.tradingCompanyRequired)
            setShowTrading(true);
          else {
            setShowTrading(false);
          }
        }

        setLoading(false);
      }
      ))
        .catch((error) => {
          console.log(error);
          setLoading(false);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });

    }

    function SaveChanges(
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      close: boolean
    ) {
      if (isSaveValid(true)) {
        event.preventDefault();
        event.stopPropagation();

        let m = model;
        if (m) {
          m.deliveryAddress = poDeliveryAddress;
          m.deliveryTo = poDeliveryTo;
          m.deliveryAttention = poDeliveryAttention;
          m.deliveryPhone = poDeliveryPhone;
          m.purchaseOrderItems = gridData;

          if (profitMargin !== "") {
            if (CalculateProfitMargin() < parseFloat(profitMargin))
              m.status = "WAIT";
          }

          m.manufacturerAddress = "";

          let maxSeq = Math.max(...m.purchaseOrderItems.map(item => {return item.seq ?? 1;}));
          let i = 1;
          m.purchaseOrderItems.forEach(item => {
            item.lotNo = item.seq ?? maxSeq + i;
            if (!item.endUserID) {
              item.endUserID = 0;
              item.endUser = "";
            }
            if (!item.scaw) {
              item.scaw = "";
            }
            i++;
          });

          m.purchaseCurrency = selectedPurchaseCurrency ?? "JPY";
          m.createDate = moment(m.createDate).format();

          setModel(m);
        }

        if (openMode === OpenMode.EDIT) {
          axios.put<PurchaseOrder>('Api/V1/PurchaseOrder/', m).then(
            (result) => {
              if (result.data.purchaseOrderItems?.length > 0) {
                result.data.purchaseOrderItems.forEach(i => {
                  i.id = i.lotNo;
                });

                setGridData(result.data.purchaseOrderItems)
              }

              let temp: any = { ...model };
              temp = result.data;
              temp.mobile = "";
              temp.email = "";
              temp.loginName = "";
              setModel(temp);

              showSnackBar("PurchaseOrder saved successfully.", "", "success");
              hasChanges.current = false;
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              console.log(error);
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          );
        }
        else {
          axios.post<PurchaseOrder>('Api/V1/PurchaseOrder/', m).then(
            (result) => {
              if (result.data.purchaseOrderItems?.length > 0) {
                result.data.purchaseOrderItems.forEach(i => {
                  i.id = i.lotNo;
                });

                setGridData(result.data.purchaseOrderItems)
              }

              let temp: any = { ...model };
              temp = result.data;
              temp.mobile = "";
              temp.email = "";
              temp.loginName = "";
              setModel(temp);

              showSnackBar("PurchaseOrder created successfully.", "", "success");
              hasChanges.current = false;
              setSaved(true);
              setDisablePreviewButton(false);
              setOpenMode(OpenMode.EDIT);
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              console.log(error);
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          );
        }
      }
    }

    function Preview(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
      let m = model;
      if (m)
        viewerModalRef.current?.Initialise(m.poNo);
    }

    function PopulateSelectedEndUser(hasSelection: boolean, endUserListItem: React.MutableRefObject<EndUserListItem>) {
      if (!hasSelection)
        return;

      let m = model;
      if (m) {
        m.endUser = endUserListItem.current.endUserName;
        m.endUserID = endUserListItem.current.endUserId;
        setModel(m);
      }
      setCopyEndUser(endUserListItem.current.endUserName);
      setCopyEndUserId(endUserListItem.current.endUserId);
    }

    function PopulateSelectedProducts(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>) {
      if (!hasSelection)
        return;

      let newPoItems: PurchaseOrderItem[] = [];
      let m = model;
      if (m) {
        let lotNos: number[] | undefined = gridData.map(i => i.lotNo);

        let maxLotNo: number = 1;
        if (lotNos && lotNos.length > 0) {
          maxLotNo = Math.max(...lotNos) + 1;
        }

        productItems.current.forEach((item) => {
          let purchaseRate = item.minPOPercent == 0 ? 0.55 : item.minPOPercent / 100;
          let sellingRate = item.minQuotationPercent == 0 ? 0.7 : item.minQuotationPercent / 100;
          let calculatedBuyPrice = parseInt(FormatNumber((item.price ?? 0) * purchaseRate, 0).replaceAll(',', ''));
          let calculatedSellPrice = parseFloat(FormatNumber((item.price ?? 0) * sellingRate * (m?.exRate ?? 0), 2).replaceAll(',', ''));
          let productDescription: string = "";
          switch (m?.languageID ?? 1) {
            case 1:
              productDescription = item.nameEng ?? (item.nameChi ?? (item.nameJpn ?? ""));
              break;
            case 2:
              productDescription = item.nameJpn ?? (item.nameChi ?? (item.nameEng ?? ""));
              break;
            case 3:
              productDescription = item.nameChi ?? (item.nameJpn ?? (item.nameEng ?? ""));
              break;
            case 4:
              productDescription = (item.nameEng ?? "") + " " + (item.nameChi ?? "");
              break;
            case 5:
              productDescription = (item.nameEng ?? "") + " " + (item.nameJpn ?? "");
              break;
          }

          const poItem: PurchaseOrderItem = {
            id: maxLotNo,
            poNo: m?.poNo ?? "",
            lotNo: maxLotNo,
            productID: item.productID,
            qty: item.minOrderQty ?? 1,
            purchasePercent: purchaseRate * 100,
            euPrice: calculatedSellPrice,
            productDesc: productDescription,
            discountCode: "",
            nameJpn: item.nameJpn, //Dummy field for saving po item
            nameChi: item.nameChi, //Dummy field for saving po item
            nameEng: item.nameEng, //Dummy field for saving po item
            description: item.description, //Dummy field for saving po item
            productCode: item.productCode, //Dummy field for saving po item
            model: item.model, //Dummy field for saving po item
            price: item.price,
            unit: item.unit,
            minOrderQty: item.minOrderQty, //Dummy field for saving po item
            endUser: undefined,
            endUserID: undefined,
            decimalPlace: 2, //Dummy field for saving po item
            osQty: item.minOrderQty ?? 1,
            purchasePrice: AwayFromZeroRounding(calculatedBuyPrice, 0),
            sellingPercent: sellingRate * 100,
            reqDel: "",
            region: "",
            partNo: "",
            poCustomerPO: "",
            customerPO: "", //Dummy field for saving po item
            seq: maxLotNo,
            scaw: item.scaw, //Dummy field for saving po item
            purchaseCurrency: "JPY", //Dummy field for saving po item
            currency: "JPY", //Dummy field for saving po item
            isSample: false, //Dummy field for saving po item
            osRecQty: 0, //Dummy field for saving po item
            actDel: ""
          };
          newPoItems.push(poItem);
          maxLotNo++;
        }
        )

        let tempData = [...gridData, ...newPoItems];
        setGridData(tempData);

        m.purchaseOrderItems = tempData;
        setModel(m);
      }

    }

    function FillCustomerAddress(hasSelection: boolean, customerAddressItem: React.MutableRefObject<CustomerAddressItem>) {
      if (!hasSelection)
        return;

      setPoDeliveryAddress(customerAddressItem.current.address);
    }

    function FillCustomerContactPerson(hasSelection: boolean, customerContactPersonItem: React.MutableRefObject<CustomerContactPersonItem>) {
      if (!hasSelection)
        return;

      setPoDeliveryAttention(customerContactPersonItem.current.contactPerson);
    }

    return (
      <div>
        <Modal open={open} onClose={() => closeModalCheck(true)}>
          <div className={style.ModalMain}>
            {model && !loading ? (
              <div className={style.ModalBody}>
                <Title pageTitle="PurchaseOrder" />
                <div className={style.ModalContent}>
                  <div className={style.ModalFields}>
                    <CustomDropDown1 className={style.ModalContentField}
                      dropDownBoxWidth={tinyScreen ? "70px" : (smallScreen ? "85px" : "100px")}
                      firstTextBoxWidth={tinyScreen ? "calc(100% - 70px)" : (smallScreen ? "calc(100% - 85px)" : "calc(100% - 100px)")}
                      firstTextBoxMinWidth={tinyScreen ? "174px" : (smallScreen ? "260px" : "375px")}
                      dropDownBoxId="region-dropdown" dropDownBoxLabel="Region" dropDownBoxDisabled={disableRegionDropDown}
                      firstTextBoxLabel="Purchase Order No" firstTextBoxName="txtPurchaseOrderNo"
                      dropDownBoxValue={region} dropDownBoxOptions={props.regions}
                      firstTextBoxValue={model.poNo}
                      onSelectionChanged={RegionChanged} />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <div className={style.ModalInnerContentFieldOneThirdWidthLeft}
                        style={{ minWidth: tinyScreen ? "110px" : (smallScreen ? "140px" : "170px") }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            key="poDate"
                            label="Purchase Order Date"
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            value={Date.parse(model.createDate)}
                            onChange={(newValue) => Update("createDate", moment(newValue).format('YYYY/MM/DD'))}
                            renderInput={(params) =>
                              <TextField {...params} sx={{ width: '100%' }} size="small" />
                            }
                          />
                        </LocalizationProvider>
                      </div>
                      <Autocomplete className={style.ModalInnerContentFieldTwoThirdWidthRight}
                        limitTags={2}
                        onChange={(e, selected) => {
                          let temp: any = { ...model };
                          temp.staffID = Number(selected?.value);
                          temp.staff = selected?.name;
                          setModel(temp);
                        }}
                        options={props.sales}
                        getOptionLabel={(option: DropDownComboOption) => option.name}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.value}>
                              {option.name}
                            </li>
                          );
                        }}
                        value={props.sales.find(s => s.value === model.staffID?.toString()) || null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={"Sales"}
                          />
                        )}
                        size="small"
                      />
                    </div>
                    <Autocomplete className={style.ModalContentField}
                      limitTags={2}
                      onChange={(e, selected) => CustomerChanged(selected)}
                      options={filteredCustomers}
                      getOptionLabel={(option: DropDownComboOption) => option.name}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.value}>
                            {option.name}
                          </li>
                        );
                      }}
                      value={filteredCustomers.find(s => s.value === ((model.customerID ?? 1) + model.custLangID * 100000).toString()) || null}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label={"Customer"}
                          size="small"
                        />
                      )}
                      size="small"
                    />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldLeft}
                        value={poDeliveryAttention}
                        label="Delivery Attention"
                        onChange={(e) => setPoDeliveryAttention(e.target.value.slice(0, 30))}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={(e) => AddCustomerContactPerson()}><Add /></IconButton>
                            </InputAdornment>
                          ),
                        }}
                        size="small"
                      />
                      <TextField className={style.ModalInnerContentFieldRight}
                        value={poDeliveryPhone}
                        label="Delivery Tel"
                        onChange={(e) => setPoDeliveryPhone(e.target.value.slice(0, 25))}
                        size="small"
                      />
                    </div>
                  </div>
                  <div className={style.ModalFields}>
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldOneThirdWidthLeft}
                        value={model.languageID}
                        onChange={(e) => LanguageChanged(parseInt(e.target.value))}
                        style={{ minWidth: tinyScreen ? "80px" : (smallScreen ? "110px" : "140px") }}
                        select
                        label="Language"
                        size="small"
                      >
                        {Languages.map((item) => (
                          <MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>
                        ))}
                      </TextField>
                      <TextField className={style.ModalInnerContentFieldTwoThirdWidthRight}
                        value={model.customerPO}
                        label="Customer PO"
                        onChange={(e) => Update("customerPO", e.target.value.slice(0, 50))}
                        size="small"
                      />
                    </div>
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldLeft}
                        value={model.attention}
                        label="Japan Contact"
                        onChange={(e) => Update("attention", e.target.value.slice(0, 30))}
                        size="small"
                      />
                      <div className={style.ModalInnerContentFieldRight}>
                        <FormControlLabel
                          style={{ display: 'block', minWidth: tinyScreen ? "130px" : (smallScreen ? "160px" : "190px") }}
                          control={<Checkbox checked={sendToHongKong} onChange={(e) => SendToHongKongChanged(e)} />}
                          label={labelSendTo}
                        />
                      </div>
                    </div>
                    <TextField className={style.ModalContentField}
                      value={poDeliveryTo}
                      label="Delivery To"
                      onChange={(e) => {
                        setPoDeliveryTo(e.target.value);
                        if (e.target.value === deliveryTo || e.target.value === deliveryToSS)
                          setSendToHongKong(true);
                        else
                          setSendToHongKong(false);
                      }}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                    />
                    <TextField className={style.ModalContentField}
                      value={poDeliveryAddress}
                      label="Delivery Address"
                      onChange={(e) => setPoDeliveryAddress(e.target.value.slice(0, 250))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      multiline
                      rows={GetNoOfLines(model.deliveryAddress)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={(e) => AddCustomerAddress()}><Add /></IconButton>
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </div>
                  <div className={style.ModalFields}>
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldOneThirdWidthLeft}
                        label="Purchase Currency"
                        value={selectedPurchaseCurrency}
                        disabled={disablePurchaseCurrency}
                        onChange={(e) => setSelectedPurchaseCurrency(e.target.value)}
                        style={{ minWidth: tinyScreen ? "80px" : (smallScreen ? "110px" : "140px") }}
                        select
                        size="small"
                      >
                        {props.currencies.map((item) => (
                          <MenuItem key={item.name + "-" + item.value} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField className={style.ModalInnerContentFieldTwoThirdWidthRight}
                        value={model.arrivalDate}
                        label="Flight Date"
                        onChange={(e) => Update("arrivalDate", e.target.value.slice(0, 50))}
                        size="small"
                      />
                    </div>
                    <Autocomplete className={style.ModalContentField}
                      limitTags={2}
                      onChange={(e, selected) => {
                        let temp: any = { ...model };
                        temp.manufacturerID = Number(selected?.value);
                        temp.manufacturerName = selected?.name;
                        if (temp.manufacturerID === 1) {
                          setSelectedPurchaseCurrency("JPY");
                          setDisablePurchaseCurrency(true);
                        }
                        else {
                          setSelectedPurchaseCurrency("RMB");
                          setDisablePurchaseCurrency(false);
                        }

                        setModel(temp);
                      }}
                      options={props.manufacturers ?? []}
                      getOptionLabel={(option: DropDownComboOption) => option.name}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.value}>
                            {option.name}
                          </li>
                        );
                      }}
                      value={props.manufacturers?.find(s => s.value === (model.manufacturerID ?? 1).toString()) || null}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label={"Manufacturer"}
                          size="small"
                        />
                      )}
                      size="small"
                    />
                    <TextField className={style.ModalContentFieldHalfWidth}
                      value={model.remark}
                      label="Remark"
                      onChange={(e) => Update("remark", e.target.value.slice(0, 250))}
                      multiline
                      rows={GetNoOfLines(model.remark)}
                      size="small"
                    />
                  </div>
                  <div className={style.ModalFields}>
                    <TextField className={style.ModalContentField}
                      id="delivery-method"
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      value={model.deliveryMethod}
                      onChange={(e) => Update("deliveryMethod", e.target.value)}
                      select
                      label="Delivery Method"
                      size="small"
                    >
                      {props.deliveryMethods.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField className={style.ModalContentField}
                      id="payment-term"
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      value={model.paymentTerm}
                      onChange={(e) => Update("paymentTerm", e.target.value)}
                      select
                      label="Payment Term"
                      size="small"
                    >
                      {props.paymentTerms.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </TextField>
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <CustomDropDown1 className={style.ModalInnerContentFieldLeft}
                        dropDownBoxWidth={tinyScreen ? "70px" : (smallScreen ? "85px" : "100px")}
                        firstTextBoxWidth={tinyScreen ? "calc(100% - 70px)" : (smallScreen ? "calc(100% - 85px)" : "calc(100% - 100px)")}
                        firstTextBoxMinWidth={tinyScreen ? "60px" : (smallScreen ? "75px" : "90px")}
                        dropDownBoxId="currency-dropdown" dropDownBoxLabel="CCY" dropDownBoxDisabled={false} firstTextBoxLabel="Ex. Rate" firstTextBoxName="txtExRate"
                        dropDownBoxValue={model.currency} dropDownBoxOptions={props.currencies}
                        firstTextBoxValue={model.exRate.toString()} firstTextBoxReadOnly={false}
                        type="number"
                        onSelectionChanged={CurrencyChanged}
                        onTextBoxValueChanged={ExRateChanged} />
                      <NumberFormat className={`${style.ModalInnerContentFieldRight}`}
                        customInput={TextField}
                        value={profitMargin}
                        label="Profit Margin"
                        error={profitMarginErrorText !== ""}
                        helperText={profitMarginErrorText}
                        decimalScale={1}
                        thousandSeparator
                        onValueChange={(e) => {
                          if (e.value !== "") {
                            let msg = ValidateNumber(e.value, NumberTypes.FLOAT, true);
                            setProfitMarginErrorText(msg);
                            if (msg === "")
                              setProfitMargin(e.value);
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Percent />
                            </InputAdornment>
                          ),
                        }}
                        size="small"
                      >
                      </NumberFormat>
                    </div>
                    <Autocomplete className={style.ModalContentField}
                      limitTags={2}
                      onChange={(e, selected, reason) => TradingCompanyChanged(selected, reason)}
                      options={tradingCompanies ?? []}
                      getOptionLabel={(option: DropDownComboOption) => option.name}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.value}>
                            {option.name}
                          </li>
                        );
                      }}
                      value={selectedTradingCompanyOption}
                      style={{
                        minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px"),
                        visibility: showTrading ? 'visible' : 'collapse'
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label={"Trading Company"}
                          size="small"
                        />
                      )}
                      size="small"
                    />
                  </div>
                  <div className={style.DataGridContent} style={{ minHeight: "280px" }}>
                    <div style={{ height: 60 }}>
                      <FakeDataGrid
                        rows={fakeGridData}
                        columns={fakeGridColumns}
                        hideFooter={true}
                        autoHeight
                      />
                    </div>
                    <StyledBox>
                      <DataGridPro
                        getRowId={(row) => row.id}
                        rows={gridData}
                        columns={columns}
                        pageSize={searchData.pageSize}
                        onPageSizeChange={(pageSize) => setSearchData({ ...searchData, pageSize: pageSize })}
                        pagination
                        rowsPerPageOptions={[10, 20, 40]}
                        loading={loading}
                        checkboxSelection
                        components={{
                          Footer: CustomTablePagination
                        }}
                        componentsProps={{
                          footer: { rowsPerPageOptions: [10, 20, 40] }
                        }}
                        selectionModel = {selectionModel}
                        onSelectionModelChange={(selections) => {
                          setSelectionModel(selections);
                          const ids = new Set(selections);
                          const selectedRows = gridData.filter((row) => ids.has(row.lotNo));
                          selectedData.current = selectedRows;
                        }}
                        disableSelectionOnClick={true}
                        onRowClick = {(param) => {
                          setSelectedItem(param.row);
                        }}
                        headerHeight={tinyScreen ? 28 : (smallScreen ? 32 : 36)}
                        rowHeight={tinyScreen ? 20 : (smallScreen ? 24 : 28)}
                        showCellRightBorder={false}
                        rowSpacingType='border'
                        showColumnRightBorder={false}
                      />
                    </StyledBox>
                  </div>
                </div>

                <div className={style.ModalFooter}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    onClick={(e) => SaveChanges(e, false)}
                  >
                    Save
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    disabled={disablePreviewButton}
                    onClick={(e) => Preview(e)}
                  >
                    Preview
                  </Button>
                  <Button
                    variant="contained"
                    className={style.margin}
                    onClick={(e) => closeModalCheck(false)}
                  >
                    Close
                  </Button>
                </div>

              </div>
            ) : (
              <div style={{ textAlign: "center" }}>
                <CircularProgress color="primary" />
              </div>
            )}
          </div>
        </Modal>

        <SnackBarMessage {...snackSettings} />

        <GeneralDialog
          title={"Save Changes?"}
          message={
            "Changes have been made, did you want to save before closing?"
          }
          open={dialogOpen}
          options={[
            {
              text: "Save",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => SaveChanges(event, true),
              color: "secondary",
              variant: "contained",
            },
            {
              text: "No",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => closeDialog(),
              color: "primary",
              variant: "contained",
            },
          ]}
        />

        <ProductList
          ref={productListModalRef}
          onClose={(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>) => PopulateSelectedProducts(hasSelection, productItems)}
        />

        <EndUserList
          ref={endUserListModalRef}
          onClose={(hasSelection: boolean, endUserListItem: React.MutableRefObject<EndUserListItem>) => PopulateSelectedEndUser(hasSelection, endUserListItem)}
          customers={props.customers}
          regions={props.regions} />

        <PurchaseOrderViewer ref={viewerModalRef} onClose={() => { }} />

        <CustomerAddress
          ref={customerAddressModalRef}
          onClose={(hasSelection: boolean, customerAddressItem: React.MutableRefObject<CustomerAddressItem>) => FillCustomerAddress(hasSelection, customerAddressItem)} />

        <CustomerContactPerson
          ref={customerContactPersonModalRef}
          onClose={(hasSelection: boolean, customerContactPersonItem: React.MutableRefObject<CustomerContactPersonItem>) => FillCustomerContactPerson(hasSelection, customerContactPersonItem)} />

      </div>
    );


  }

);
